module.exports = __webpack_public_path__ + "img/pg-slot-logo.81aa8a60.png";